export function element<T extends HTMLElement = HTMLElement>(id: string): T {
  const found = document.getElementById(id);
  if (!found) throw new Error(`Missing view element #${id}`);
  return found as T;
}

export function make<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className = "",
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}

export function mountToast(root: HTMLElement): (message: string) => void {
  let timer = 0;
  return (message) => {
    clearTimeout(timer);
    root.textContent = message;
    root.hidden = false;
    timer = window.setTimeout(() => (root.hidden = true), 5000);
  };
}
